<template>
  <v-container fluid class="pt-10">
  <template v-if="loading">
    <v-row justify="center" align-content="center" class="mt-10">
      <img src="../../assets/loading.gif">
    </v-row>
  </template>
  <template v-else>
    <v-row max-width="1920" justify="center">
      <v-col cols="12" md="3" :style="{ width: activeWidth, maxWidth: activeMaxWidth }" order="last" order-md="first">
        <v-card class="pb-2">
          <v-card-title class="justify-center">
            <v-avatar size="84" depressed>
              <v-img :src="icon" alt="icon" max-height="84" max-width="84"></v-img>
            </v-avatar>
          </v-card-title>
          <v-card-subtitle class="text-center pt-4 pb-0 justify-center">
            <p class="text-h6 mb-0">{{ user.name }}</p>
            <p class="text-subtitle1 mb-0">{{ user.user_code }}</p>
          </v-card-subtitle>
          <v-card-subtitle class="text-center pb-0 justify-center">
            <template v-if="isAuth && !isMyTopic">
              <v-btn @click="userFavorite" outlined color="primary" small :loading="userFavoritedLoading">
                <template v-if="isUserFavorited">
                 <span class="font-weight-bold">お気に入り解除をする</span>
                </template>
                <template v-else>
                  <span class="font-weight-bold">お気に入りをする</span>
                </template>
              </v-btn>
            </template>
          </v-card-subtitle>
          <v-card-actions class="text-center pb-0 justify-center">
            <template v-if="user.user_code">
              <v-btn :href="'/user/' + user.user_code" outlined color="primary">
                <span class="font-weight-bold">その他の記事を見る</span>
              </v-btn>
            </template>
          </v-card-actions>
        </v-card>
        <v-card class="mt-4 py-4 sm-recently-viewed-topics" v-if="cookie_topics !== null">
          <div class="text-center mb-4">
            <hr class="hr-text" data-content="最近見たトピック">
          </div>
          <ul style="list-style: none; margin-right: 20px">
            <li v-for="(cookie_topic, topic_code) in cookie_topics"
            :key="topic_code"

            >
              <div class="mb-1">
                <v-avatar size="30" depressed>
                  <v-img :src="cookie_topic.icon_url" width="30" height="30"></v-img>
                </v-avatar>
                <span class="ml-2 font-weight-bold" style="color: #9E9EA7;">{{ cookie_topic.user_name }}</span>
              </div>
                <a
                  class="font-weight-bold"
                  :href="`/topic/${topic_code}`"
                  style="font-size: 16px; text-decoration: none; color: black;"
                ><span style="width: 150px; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis;">{{ cookie_topic.topic_name }}</span></a>
              <hr class="hr-text">
            </li>
          </ul>
        </v-card>
      </v-col>
      <v-col style="max-width:1080px;" order="first" order-md="0">
        <v-card :class="cardClass">
          <v-card-title class="text-h4 topic-title">
            {{ topic.topic_name }}
          </v-card-title>
          <v-card-text class="pt-0">
            <v-chip-group
              active-class="label deep-purple accent-4 white--text"
              column
              class="pb-2"
            >
              <div v-for="tag in topic.tags" :key="tag.tag_name">
                <v-btn 
                  depressed
                  dark
                  color="#333333"
                  @click="searchTag(tag.tag_name)"
                  small 
                  class="mb-4 mr-2 font-weight-bold tag-name"
                  style="text-transform: none"
                  >{{ tag.tag_name }}</v-btn>
              </div>
            </v-chip-group>
            <v-row align="end">
              <v-col cols="12">
                <v-row class="">
                  <v-col md="3" sm="4" class="topic-updated-at">
                    <time :datetime="formatDate(topic.updated_at)">更新日：{{ formatDate(topic.updated_at) }}</time>
                  </v-col>
                  <v-col md="3" sm="4" class="topic-preview-count">
                    いいね数：{{ topic.lgtm }}
                  </v-col>
                  <v-col md="3" sm="4" class="topic-preview-count">
                    閲覧数：{{ topic.preview_count }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row justify="end" align="end">
                  <template v-if="isMyTopic">
                    <v-btn :to="{ name: 'topic_edit', params: { topic_code: topicCode }}" outlined class="ml-2" color="primary mr-1" height="28" width="100">
                      <v-icon>mdi-pencil</v-icon>編集
                    </v-btn>
                    <v-btn @click="bookmarkExport" outlined color="primary mr-1" class="ml-2" height="28" width="100">
                      <v-icon>mdi-file-export-outline</v-icon>export
                    </v-btn>
                  </template>
                  <template v-else-if="isWriting">
                    <v-btn v-if="topic.is_writing === 'edit_ok'" :to="{ name: 'topic_edit', params: { topic_code: topicCode }}" outlined class="ml-2" color="primary ml-1" height="28" width="100">
                      <v-icon>mdi-pencil</v-icon>編集
                    </v-btn>
                    <v-btn v-else outlined class="ml-2" color="primary mr-2" height="28" width="100" @click="openModal()">
                      <v-icon>mdi-pencil</v-icon>編集権限リクエスト
                    </v-btn>
                  </template>
                  <v-tooltip bottom v-model="showCopied">
                    <template v-slot:activator="{}">
                      <v-btn @click="copy()" outlined color="primary mr-1" class="ml-2" height="28" width="100" location>
                        <v-icon>mdi-link-variant</v-icon>コピー
                      </v-btn>
                    </template>
                    <span>URL Copied to Clipboard!!</span>
                  </v-tooltip>
                  <v-btn @click="openQrcodeModal()" outlined color="primary mr-1" class="ml-2" height="28" width="100">
                    <v-icon>mdi-qrcode</v-icon>QRコード
                  </v-btn>
                  <template v-if="isAuth">
                    <v-btn @click="favorite" outlined color="primary mr-1" class="ml-2" height="28" width="100" :loading="favoritedLoading">
                      <template v-if="isFavorited">
                        <v-icon>mdi-heart-broken</v-icon>Unlike
                      </template>
                      <template v-else>
                        <v-icon>mdi-heart</v-icon>Like
                      </template>
                    </v-btn>
                  </template>
                  <template v-if="isMyTopic">
                    <v-btn @click="deleteTopic" outlined color="red" class="ml-2" height="28" width="100">
                      <v-icon>mdi-delete</v-icon>削除
                    </v-btn>
                  </template>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-if="topic.information_text !== null" class="text-h6">
            <p style="white-space:pre-wrap; margin-bottom: 0px;">{{ topic.information_text }}</p>
          </v-card-text>
          <div v-for="(parts, index) in topic.topic_parts" v-bind:key="parts.topic_part_id">
            <template v-if="parts.information_text !== null">
              <div class="paper mt-4">
                <h3 v-if="parts.title !== null" class="paper-content-title" :ref="'title' + index"><span class="part-title">{{parts.title}}</span></h3>
                <mavon-editor
                  language="ja"
                  class="paper-content"
                  v-model="parts.information_text"
                  :subfield="false"
                  :editable="false"
                  :toolbarsFlag="false"
                  :boxShadow="false"
                  defaultOpen="preview"
                  previewBackground="#11ffee00"
                  codeStyle='a11y-dark'
                  :xssOptions="{
                    whiteList: {
                      iframe: ['src', 'height', 'width'],
                      div: ['style', 'height', 'width', 'align']
                    }
                  }"
                ></mavon-editor>
              </div>
              <div class="husen mt-4 pb-4" >
                <blockquote :cite="parts.url">
                  <cite><a :href="parts.url" target="_blank" style="display: block;" class="mt-4"><p class="lineClamp">{{parts.url}}</p></a></cite>
                  <LinkPreview v-bind:url="parts.url" :apiUrl="linkPreviewApi">
                    <template slot-scope="props">
                      <div class="card-block">
                        <v-row align="center" justify="space-around">
                          <v-col cols=12 sm=8>
                            <p class="text-h6 mb-0">{{props.title}}</p>
                            <p class="mb-0">{{props.description}}</p>
                          </v-col>
                          <v-col cols=12 sm=4>
                            <img :src="props.img" :alt="props.title" class="mt-0" height="113" width="198"  v-if="props.title">
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                    <template slot="loading">
                      <v-row align="center" justify="center" class="mt-10">
                        <i class="fa fa-spinner fa-pulse fa-2x fa-fw" style="color: purple"></i>
                      </v-row>
                    </template>
                  </LinkPreview>
                </blockquote>
              </div>
            </template>
            <template v-if="parts.information_text === null">
              <v-card class="overflow-hidden mx-auto mt-4" outlined>
              <v-card-title>
                <span class="text-h5" :ref="'title' + index">{{parts.title}}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="">
                <p class="text-body1" v-html="sanitizeMarkdown(parts.information_text)"></p>
                <a v-bind:href="parts.url" target="_blank" style="display: block;"><p class="lineClamp">{{parts.url}}</p></a>
                <LinkPreview v-bind:url="parts.url" :apiUrl="linkPreviewApi">
                  <template slot-scope="props">
                    <div class="card-block">
                      <v-row align="center" justify="space-around">
                        <v-col cols=12 sm=8>
                          <p class="text-h6 mb-0">{{props.title}}</p>
                          <p class="mb-0">{{props.description}}</p>
                        </v-col>
                        <v-col cols=12 sm=4>
                          <img :src="props.img" :alt="props.title" class="mt-0" height="113" width="198"  v-if="props.title" onerror="this.src='https://image.vla.tips/topic_image/noimage.png';">
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template slot="loading">
                    <v-row align="center" justify="center" class="mt-10">
                      <i class="fa fa-spinner fa-pulse fa-2x fa-fw" style="color: purple"></i>
                    </v-row>
                  </template>
                </LinkPreview>
              </v-card-text>
              </v-card>
            </template>
          </div>
          <div>
            <v-card class="text-right mx-auto mt-4">
              <SocialNetwork :topic="topic"/>
            </v-card>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" :style="{ width: activeWidth, maxWidth: activeMaxWidth }" order="0" order-md="last">
        <v-card class="pb-2">
          <p class="text-center mb-4 pt-4 font-weight-bold">目次</p>
          <ul style="list-style: none; margin-right: 20px;">
            <li style="margin-bottom: 10px;" v-for="title in titles" :key="title.id" :id="title.id">
              <a class="btn-primary" style="font-size: 14px;" @click="scrollToAnchorTopicTitle(title.id)">
                {{ title.name }}
              </a>
            </li>
          </ul>
        </v-card>
      </v-col>
    </v-row>
    <EditTopicPermissionRequestModal :user="user" />
    <QrcodeModal 
      :isOpenQrcodeModal="isOpenQrcodeModal"
      :isCloseQrcodeModal="closeQrcodeModal"
      :topic="topic"
    />
    <DeleteConfirmModal
      :isOpenDeleteConfirmModal="isOpenDeleteConfirmModal"
      :isCloseDeleteConfirmModal="closeDeleteConfirmModal"
      :topic_id="topic.topic_id"
    />
  </template>
  </v-container>
</template>
<script>
import marked from 'marked'
import dayjs from 'dayjs'
import LinkPrevue from 'link-prevue'
import EditTopicPermissionRequestModal from '../organisms/EditTopicPermissionRequestModal.vue'
import SocialSharing from 'vue-social-sharing'
import SocialNetwork from '../organisms/SocialNetwork.vue'
import LinkPreview from '../molecules/LinkPreview.vue'
import QrcodeModal from '../organisms/QrcodeModal.vue'
import DeleteConfirmModal from '../molecules/DeleteConfirmModal.vue'

export default {
  name: 'TopicDetail',
  components: {
    // ライブラリ
    LinkPrevue,
    // オリジナル
    LinkPreview,
    // VueCookie,
    SocialSharing,
    EditTopicPermissionRequestModal,
    SocialNetwork,
    QrcodeModal,
    DeleteConfirmModal
  },
  data() {
    return {
      showCopied: false,
      topic: '',
      cookie_topics: '',
      topic_image_url: '',
      topicDetail: '',
      topicCode: this.$route.params.topic_code,
      favorited: false,
      favoritedLoading: true,
      userFavorited: false,
      userFavoritedLoading: true,
      my_topic: false,
      is_auth: false,
      loading: true,
      is_writing: false,
      cardClass: "pa-8",
      user: [],
      headers: [
          {
            text: 'ID',
            value: 'user_id'
          },
          {
            text: '名前',
            value: 'user_code',
          },
      ],
      titles: [],
      linkPreviewApi: process.env.VUE_APP_LINK_PREVIEW_API_URL,
      isOpenQrcodeModal: false,
      isOpenDeleteConfirmModal: false,
      activeWidth: "none",
      activeMaxWidth: "230px",
    }
  },
  computed: {
    isFavorited: function() {
      return this.favorited
    },
    // ユーザーお気に入り
    isUserFavorited: function() {
      return this.userFavorited
    },
    getUserCode: function() {
      return this.$store.getters['auth/isUserCode']
    },
    isAuth() {
      return this.is_auth
    },
    isMyTopic() {
      return this.my_topic
    },
    isWriting() {
      return this.is_writing
    },
    image() {
      return this.topic.topic_image_url;
    },
    icon: function() {
      return this.user.icon_url
    },
    isOpenModal() {
			return this.$store.getters['inquiryModal/isOpen']
    },
  },
  methods: {
    bookmarkExport() {
      this.$axios.post(process.env.VUE_APP_API_BASE_URL + '/export_bookmark', {topic_code: [this.topicCode]}, {responseType: "blob"})
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'vla_bookmark.html');
          document.body.appendChild(link);
          link.click();
          link.revokeObjectURL();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchTag($tag) {
      this.$router.push({ path: '/search_result', query: { tag: $tag } })
    },
    scrollToAnchorTopicTitle(key) {
      const topicTitle = this.$refs[key]
      topicTitle[0].scrollIntoView({ behavior: 'smooth', block: "center"})
    },
    // お気に入り
    favorite: function() {
      this.favoritedLoading = true;
      if(this.favorited){
        this.$store.dispatch('favorite/topicDelete', this.topic)
            .then(() => {
              this.favorited = false;
              this.favoritedLoading = false;
              this.topic.lgtm = Number(this.topic.lgtm) - 1
            })
      } else {
        this.$store.dispatch('favorite/topicRegister', this.topic)
            .then(() => {
              this.favorited = true;
              this.favoritedLoading = false;
              this.topic.lgtm = Number(this.topic.lgtm) + 1
            })
      }
    },
    userFavorite: function() {
      this.userFavoritedLoading = true;
      if(this.userFavorited){
        this.$store.dispatch('favorite/userDelete', this.user.user_code)
          .then(() => {
            this.userFavorited = false;
            this.userFavoritedLoading = false;
          })
      } else {
        this.$store.dispatch('favorite/userRegister', this.user.user_code)
          .then(() => {
            this.userFavorited = true;
            this.userFavoritedLoading = false;
          })
      }
    },
    async copy() {
      navigator.clipboard.writeText(process.env.VUE_APP_BASE_URL + '/topic/' + this.topicCode)
      this.showCopied = true;
      await this.sleep(1000);
      this.showCopied = false;
    },
    sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    // deleteTopic() {
    //   this.$store.dispatch('topic/delete', this.topic.topic_id)
    //     .then(() => {
    //       this.$router.push('/user/' + this.getUserCode)
    //     })
    // },
    deleteTopic() {
      this.isOpenDeleteConfirmModal = true
    },
    openDeleteConfirmModal() {
      this.isOpenDeleteConfirmModal = true;
    },
    closeDeleteConfirmModal() {
      this.isOpenDeleteConfirmModal = false;
    },
    formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
    openModal() {
			const data = {
				isOpen: true
      }
			this.$store
				.dispatch('inquiryModal/actionModalOpen', data)
				.then(() => {
          this.permissionRequest();
				})
				.catch(() => {})
		},
    permissionRequest() {
      this.$axios.post(process.env.VUE_APP_API_BASE_URL + '/topic_permission', {topic_code: this.topicCode})
        .then(() => {});
    },
    compiledMarkdown(informationText) {
      if (informationText !== null) {
        return marked(informationText);
      }
      return '';
    },
    sanitizeMarkdown(informationText) {
      const compiledMarkdown = this.compiledMarkdown(informationText);
      return compiledMarkdown;
    },
    async getTopics() {
      await this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/topic/' + this.$route.params.topic_code, {
        withCredentials: true
      })
        .then(response => {
          this.topic = response.data
          // もしtableがあったらtableにボーダーラインを付与している
          // for(const key in this.topic.topic_parts) {
          //   if (this.topic.topic_parts[key].information_text !== null && marked(this.topic.topic_parts[key].information_text).match(/<table>/)) {
          //     this.topic.topic_parts[key].information_text = marked(this.topic.topic_parts[key].information_text).replace(/<table>/g, '<table border="1" style="border-collapse: collapse">');
          //   }
          // }
          if(this.topic.image_url) {
            this.topic.image_url = process.env.VUE_APP_IMAGE_BUCKET_URL + this.topic.image_url
          }
          if(this.topic.user_code === this.getUserCode) {
            this.my_topic = true
          }
          if(this.getUserCode) {
            this.is_auth = true
            this.$store.dispatch('favorite/topics', this.getUserCode)
              .then(response => {
                response.map(topic => {
                  if(this.topic.topic_code === topic.topic_code) {
                    this.favorited = true;
                    this.favoritedLoading = false;
                  }
                })
              })
            this.$store.dispatch('favorite/users', this.getUserCode)
              .then(response => {
                response.map(user => {
                  if(this.topic.user_code === user.user_code) {
                    this.userFavorited = true;
                    this.userFavoritedLoading = false;
                  }
                })
              })
          }
          if(this.topic.is_writing !== 'edit_not') {
            this.is_writing = true
          }
          this.cookie_topics = this.topic.cookie_topics;
          let tagsTitle = this.topic.tags.map(function (tag) {
            return tag.tag_name
          });
          // default OGP
          document.title = this.topic.topic_name + '|' + tagsTitle.join('|') + '|vla.tips' 
          document.head.querySelector("[name=description]").setAttribute('content', this.topic.information_text)
          document.querySelector("meta[property='og:title']").setAttribute('content', this.topic.topic_name + '|' + tagsTitle.join('|') + '|vla.tips')
          document.querySelector("meta[property='og:description']").setAttribute('content', this.topic.information_text)
          document.querySelector("meta[property='og:url']").setAttribute('content', process.env.VUE_APP_BASE_URL + '/topic/' + this.topic.topic_code)
          document.querySelector("meta[property='og:image']").setAttribute('href', process.env.VUE_APP_BASE_URL + '/topic/' + this.topic.topic_code)
          // twitter OGP
          document.querySelector("meta[name='twitter:title']").setAttribute('content', this.topic.topic_name + '|' + tagsTitle.join('|') + '|vla.tips')
          document.querySelector("meta[name='twitter:description']").setAttribute('content', this.topic.information_text)
          document.querySelector("meta[name='twitter:url']").setAttribute('content', process.env.VUE_APP_BASE_URL + '/topic/' + this.topic.topic_code)
          document.querySelector("meta[name='twitter:image']").setAttribute('href', process.env.VUE_APP_BASE_URL + '/topic/' + this.topic.topic_code)
        })
    },
    async getUserData() {
      await this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/' + this.topic.user_code)
        .then(response => {
          this.user = response.data
          this.userFavoritedLoading = false;
        })
    },
    getTitlesFromRefs() {
      let titles = [];
      Object.keys(this.$refs).forEach(key => {
        const title = {
          'name': (this.$refs[key][0].children[0]) ? this.$refs[key][0].children[0].innerHTML : null,
          'id': key
        };
        titles.push(title);
      }, titles)
      this.titles = titles;
    },
    getTitlesFromTopic() {
      let titles = [];
      for (let i = 0; i < this.topic.topic_parts.length; i++) {
        const title = {
          'name': this.$refs[`title${i}`][0].innerHTML,
          'id': `title${i}`
        }
        titles.push(title);
      }
      this.titles = titles;
    },
    openQrcodeModal() {
      this.isOpenQrcodeModal = true;
    },
    closeQrcodeModal() {
      this.isOpenQrcodeModal = false;
    },
    isSmLayout() {
      if (this.$vuetify.breakpoint.name === 'sm') {
        return true;
      }
      return false;
    },
    isXsLayout() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return true;
      }
      return false;
    },
  },
  watch: {
    async $route(to, from) {
      // ルートの変更の検知...
      if (to.params !== from.params) {
        this.loading = true;
        this.titles = [];
        await this.getTopics();
        await this.getUserData();
        this.loading = false;
        this.$nextTick(function () {
          this.getTitlesFromTopic();
        })
        this.userFavoritedLoading = false;
        this.favoritedLoading = false;
      }
    }
  },
  created: async function () {
    await this.getTopics();
    await this.getUserData();
    this.loading = false;
    this.$nextTick(function () {
      this.getTitlesFromRefs();
    })
    this.userFavoritedLoading = false;
    this.favoritedLoading = false;
    if (this.isSmLayout() || this.isXsLayout()) {
      this.cardClass = "pa-0"
      this.activeWidth = "100%"
      this.activeMaxWidth = "none"
    }
  }
}
</script>
<style src="../../styles/sample.css" scoped>
</style>